import React from 'react';
import { motion } from 'framer-motion';
import { CheckIcon } from 'lucide-react';
const audienceItems = ['Mamás que llegan cansadas a casa y no saben qué cocinar', 'Mamás que quieren dejar de pedir delivery por desesperación', 'Mamás que tienen ingredientes básicos pero les falta la idea', 'Mamás que quieren cocinar rico, rápido y sin complicaciones', 'Mamás que necesitan variedad real para la semana'];
export function AudienceSection() {
  return <section className="w-full py-10 md:py-12 px-6 bg-cream" data-id="element-1">
      <div className="max-w-3xl mx-auto" data-id="element-2">
        <motion.h2 initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.5
      }} className="font-heading text-3xl md:text-4xl font-bold text-brown-dark text-center mb-8" data-id="element-3">
          ¿Para quién es?
        </motion.h2>

        <div className="space-y-3" data-id="element-4">
          {audienceItems.map((item, index) => <motion.div key={index} initial={{
          opacity: 0,
          x: -30
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true,
          margin: '-50px'
        }} transition={{
          duration: 0.4,
          delay: index * 0.1
        }} className="flex items-start gap-4 p-4 bg-white rounded-xl border-l-4 border-green shadow-warm" data-id="element-5">
              <div className="flex-shrink-0 w-8 h-8 bg-green/10 rounded-full flex items-center justify-center" data-id="element-6">
                <CheckIcon className="w-5 h-5 text-green" data-id="element-7" />
              </div>
              <p className="font-body text-lg text-brown-dark leading-relaxed" data-id="element-8">
                {item}
              </p>
            </motion.div>)}
        </div>
      </div>
    </section>;
}